import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CPF_PATTERN } from 'src/app/app-config';
import { AuthService } from '../../services/core/auth.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  public hidePassword: boolean = true;
  public isSignUpMode: boolean = false;

  private userFormControl = new FormControl("", [
    Validators.required,
    Validators.pattern(`^${CPF_PATTERN}( as ${CPF_PATTERN})?$`),
    Validators.minLength(11)
  ]);

  private passFormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(3)
  ]);

  public loginFormGroup = new FormGroup({
    user: this.userFormControl,
    pass: this.passFormControl
  });

  public errStr?: string;
  public subscription?: Subscription;

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.authService.isAuthenticated().subscribe((isAuth) => {
      if (isAuth === true) {
        let targetUrl = this.activatedRoute.snapshot.queryParams['url'];
        location.href = targetUrl
          ? `http://${targetUrl}`
          : environment.sistemasUrl;
      }
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

  private onLoginError(err: any) {
    console.error(`Login error: ${JSON.stringify(err)}`);

    if (err.status === 401) {
      this.errStr = 'Usuário ou senha incorretos.';
    } else if (err.status === 0) {
      this.errStr = 'Não foi possível conectar ao servidor.';
    } else if (err.status === 403) {
      this.errStr =
        'Usuário não autorizado.';
    } else {
      this.errStr = err.error.message;
    }
  }

  public onLogin() {
    this.unsubscribe();
    const userStr: string = this.userFormControl.value!.toString();
    const [user, impersonated] = userStr.replace(/\.|\-/g, "").split(" as ");
    const pass: string = this.passFormControl.value!.toString();
    this.passFormControl.setValue("");
    this.passFormControl.markAsUntouched();
    this.errStr = undefined;
    this.subscription = this.authService
      .login({ user: userStr, pass: pass })
      .subscribe({
        next: () => {
          this.unsubscribe();
          impersonated
            ? this.onMustImpersonate(impersonated)
            : this.authService.redirectToApplication();
        },
        error: (err) => {
          this.unsubscribe();
          this.onLoginError(err);
        },
      });
  }

  public onClickEsqueci() {
    const url = this.activatedRoute.snapshot.queryParams["url"];
    this.router.navigate(['esqueci'], { queryParams: { url } });
  }

  public showSignIn(): void {
    this.isSignUpMode = false;
  }

  public showSignUp(): void {
    this.isSignUpMode = true;
  }

  public onFakeSignUp(): void {
  }
  
  public togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  public redirectToSistemas() {
    window.location.href = environment.sistemasUrl;
  }

  private onMustImpersonate(cpf: string) {
    this.subscription = this.httpClient
      .get(`/api/login/impersonate`, {
        responseType: 'text',
        params: { cpf },
        withCredentials: true,
      })
      .subscribe({
        next: () => {
          this.authService.redirectToApplication();
          this.unsubscribe();
        },
        error: (err) => {
          this.unsubscribe();
          this.onLoginError(err);
        },
      });
  }

}
